import { constants, typographyStyles } from "@newsela/angelou";

const { fontFamily, fontSize, textXSObj: text4 } = typographyStyles;
const { ui, brand } = constants.colors;

export const sliderCss = {
  root: {
    color: ui.neutral[600],
    marginTop: "1.5rem",
    padding: "12px",
    borderRadius: 0,
    width: "166px",
    height: "60px",
    left: "25px",
    marginLeft: "10px",
  },
  thumb: {
    height: 24,
    width: 24,
    bottom: 0,
    backgroundColor: ui.white[500],
    border: `3px solid ${ui.neutral[600]}`,
  },
  markLabel: {
    top: "83px",
    color: ui.neutral[400],
    ...text4,

    // Overrides a known MUI styling issue seen on mobile (touchscreen) devices
    "@media (pointer: coarse)": {
      marginTop: "38px",
    },
  },
  valueLabel: {
    fontWeight: "bold",
    backgroundColor: ui.neutral[600],
    width: "56px",
    borderRadius: "5px",
    "&>span": {
      backgroundColor: ui.neutral[600],
      textAlign: "center",
      margin: "0px auto",
      display: "flex",
    },
  },
  track: {
    height: 24,
    backgroundColor: ui.neutral[600],
  },
  rail: {
    color: brand.neutral[700],
    right: 0,
    height: "4px",
    opacity: 1,
    marginLeft: "2px",
  },
  mark: {
    display: "none",
  },
} as const;

export const sliderValueLabelWrapperCss = {
  ...fontFamily.circular,
  ...fontSize.textXS,
  width: "56px",
  height: "34px",
  display: "flex",
  flexDirection: "column",
  textWrap: "wrap",
} as const;
